import { AutogenModelCallinScriptTemplate, AutogenRowCallinScriptTemplate } from "./autogen/AutogenModelCallinScriptTemplate";

export class ModelCallinScriptTemplate extends AutogenModelCallinScriptTemplate<RowCallinScriptTemplate> {
    constructor() {
        super(RowCallinScriptTemplate);
    }
}

export class RowCallinScriptTemplate extends AutogenRowCallinScriptTemplate {
}